import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class LineupScore extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "points", Model.attribute('points'));
    _defineProperty(this, "matchId", Model.attribute('matchId'));
    _defineProperty(this, "userId", Model.attribute('userId'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
    _defineProperty(this, "predictedLineup", Model.attribute('predictedLineup'));
    _defineProperty(this, "officialLineup", Model.attribute('officialLineup'));
    _defineProperty(this, "user", Model.hasOne('user'));
    _defineProperty(this, "match", Model.hasOne('match'));
  }
}
flarum.reg.add('nagusi-match-ratings', 'common/models/LineupScore', LineupScore);